import React from 'react';
import './TelemetryCard.scss';
import TelemetryCard from './TelemetryCard';
import { Flex, FlexItem, Spinner } from '@patternfly/react-core';
import PropTypes from 'prop-types';

const TelemetryCardList = ({ assetId, telemetryModelValues, isLoading, light, hideChart = false, header = null }) => {
  if (isLoading) {
    return <Spinner size="md"/>;
  }

  return (
    <>
      { header }
      <Flex flexWrap={{ default: 'wrap' }} className="telemetry-card-container">
        { telemetryModelValues.map((model, index) => {
          return (
            <FlexItem key={index + model.displayName}>
              <TelemetryCard
                light={light}
                telemetrySchema={model}
                telemetryValue={model.value}
                assetId={assetId}
                hideChart={hideChart}
              />
            </FlexItem>
          );
        }) }
      </Flex>
    </>
  );
};

TelemetryCardList.propTypes = {
  assetId: PropTypes.string,
  telemetryModelValues: PropTypes.array,
  light: PropTypes.bool
};

export default TelemetryCardList;
